const CompanyData = {
  logoList: [
    {
      imageUrl2: "ININ_logo.png",
      title: "ININ Games",
      sort: "いにんげーむす",
    },
    {
      imageUrl2: "Columbuscircle_logo.png",
      title: "コロンバスサークル",
      sort: "ころんばすさーくる",
    },
    {
      imageUrl2: "success_logo.png",
      title: "サクセス",
      sort: "さくせす",
    },
    {
      imageUrl2: "ssj_logo.png",
      title: "シルバースタージャパン",
      sort: "しるばーすたーじゃぱん",
    },
    {
      imageUrl2: "Beep_Logo.png",
      title: "BEEP",
      sort: "びーぷ",
    },
    {
      imageUrl2: "Phoenixx_logo.png",
      title: "Phoenixx",
      sort: "ふぃーにっくす",
    },
    {
      imageUrl2: "mebius_logo.png",
      title: "メビウス",
      sort: "めびうす",
    },
    {
      imageUrl2: "re_logo.png",
      title: "ロケットエンジン",
      sort: "ろけっとえんじん",
    },
    {
      imageUrl2: "APOLLOSOFT_LOGO.png",
      title: "アポロソフト",
      sort: "あぽろそふと",
    },
    {
      imageUrl2: "petidepot_logo.png",
      title: "プチデポット",
      sort: "ぷちでぽっと",
    },
    {
      imageUrl2: "kemco_logo.png",
      title: "ケムコ",
      sort: "けむこ",
    },

    {
      imageUrl2: "busirodo_logo.png",
      title: "ブシロードゲームズ",
      sort: "ぶしろーど",
    },
    {
      imageUrl2: "RS34Logo.png",
      title: "RS34",
      sort: "あーるえす",
    },

    {
      imageUrl2: "OperaHouseLogo.png",
      title: "オペラハウス",
      sort: "おぺらはうす",
    },
    {
      imageUrl2: "shanonLogo.png",
      title: "シャノン",
      sort: "しゃのん",
    },
    {
      imageUrl2: "ThousandGames_logo.png",
      title: "サウザンドゲームズ",
      sort: "さうざんどげーむず",
    },
    {
      imageUrl2: "daisyworld_logo.png",
      title: "デイジーワールド",
      sort: "でいじーわーるど",
    },
  ],

  cardList: [
    {
      imageUrl1: "Apollosoft.jpg",
      title: "アポロソフト",
      linkUrl1: "https://www.apollosoft.co.jp/",
      linkUrl2: "https://apollosoft.wixsite.com/pinbollua",
      text:
        "岐阜でゲーム開発をしております。アポロソフトと申します！<br/>今回メビウス様のイベントに参加させて頂くことになりました。<br/>「ピンボルアの勇者」はお子様でも遊んで頂ける、ＲＰＧ風ピンボールゲームです！<br/>ぜひプレイしてみてください！",
      gametitle: "ピンボルアの勇者",
      copyright: "©2020 POWE UNIT / APOLLOSOFT.",
    },

    {
      imageUrl1: "ININ2.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2: "https://iningames.jp/games/air-twister/",
      text:
        "『Air Twister』は数々の革新的なゲームを世に送り出してきたゲームクリエーター鈴木裕氏が率いる「YS NET」開発の最新作3Dレールシューティングゲームです。SFファンタジーを思わせる世界観と「Valensia」の壮大なサウンドを体験しましょう！",
      gametitle: "Air Twister",
      copyright: "© 2023 YS NET. Published by United Games Entertainment.",
    },
    {
      imageUrl1: "ININ.jpg",
      title: "ININ Games",
      linkUrl1: "https://iningames.jp/",
      linkUrl2: "https://iningames.jp/games/rainbow-cotton/",
      text:
        "ドイツのゲームパブリッシャーININです。2000年にドリキャスで発売された魔法少女コットンの本格3Dシューティング『レインボーコットン』。当時の可愛さはまるっとそのまま、最新プラットフォーム向けて今年4月にリリースします！",
      gametitle: "レインボーコットン",
      copyright:
        "©2024 SUCCESS. All Rights Reserved. Published by United Games Entertainment GmbH.",
    },

    {
      imageUrl1: "Columbuscircle.jpg",
      title: "コロンバスサークル",
      linkUrl1: "https://www.columbuscircle.co.jp/",
      //linkUrl2: "https://cosen-net.com/kanzentai/",
      text:
        "レトロゲーム互換機・新作ゲームカセット、他レトロゲーム関連商品の製造・発売でおなじみの「コロンバスサークル」です！<br/>好評発売中の新作ソフト「ストーンプロテクターズ」の展示や、前回もご好評頂きましたアウトレット品の販売を行います！",
      gametitle: "物販",
    },
    {
      imageUrl1: "success.jpg",
      title: "サクセス",
      linkUrl1: "https://www.success-corp.co.jp/",
      linkUrl2:
        "https://heavenseeker.success-corp.co.jp/?_gl=1*xr4py3*_gcl_au*MTA0NzIwNDE0OS4xNzAwNDUxNDIz*_ga*MjEyODk1NTkwNS4xNjkyMTYyODc4*_ga_66XH9XF0R9*MTcwNjc2NTY3Ni4xNzUuMC4xNzA2NzY1Njc2LjAuMC4w&_ga=2.142293426.1633364685.1706765677-2128955905.1692162878",
      text:
        "現在開発中のSteam向けゲーム『HEAVEN SEEKER コノ残酷ナ世界ノ救イ方』の体験版を展示します。<br/>アイテムの組み合わせでショットを変化させて戦うツインスティック・ローグライトシューターです。",
      gametitle: "HEAVEN SEEKER コノ残酷ナ世界ノ救イ方",
      copyright: "©SUCCESS",
    },
    {
      imageUrl1: "silverstar.jpg",
      title: "シルバースタージャパン",
      linkUrl1: "https://www.silverstar.co.jp/",
      linkUrl2: "https://www.silverstar.co.jp/02products/switch_spiral/",
      text:
        "将棋要素０！将棋メーカーがまじめに作ったお嬢様アクションゲームです。<br/>普段グッズなんて縁が無いので、喜んでグッズ作りました。",
      gametitle: "螺旋麗嬢 スパイラルお嬢様 超髪のマキナ",
      copyright: "©SilverStarJapan",
    },
    {
      imageUrl1: "beep.jpg",
      title: "BEEP",
      linkUrl1: "https://www.beep-shop.com/ec/",
      linkUrl2: "https://www.beep-shop.com/sap/radirgy2/",
      text:
        "ラジルギ２！<br/>久々のステージ制シューティングでごじゃる。<br/>撃って切ってボムで突っこんで…いや今回はボムを動かせる！１８年ぶりだけど、スタッフほぼ同じ！<br/>※開発中のため『ラジルギ』のプレイアブル出典はありません",
      gametitle: "ラジルギ2",
      copyright: "©BEEP ©RS34,INC",
    },
    {
      imageUrl1: "Phoenixx.jpg",
      title: "Phoenixx",
      linkUrl1: "https://phoenixx.ne.jp/",
      linkUrl2: "https://detectiveatsushi.phoenixx.ne.jp/",
      text:
        "TBSテレビ年末恒例のバラエティ番組『クイズ☆正解は一年後』の企画で誕生したアドベンチャーゲームが、Nintendo Switchに登場！年始に行われた番組収録で起こる凄惨な殺人事件の全貌を、レトロスタイルなコマンド式アドベンチャーで描き出します。",
      gametitle: "クイズ☆正解は一年後 presents あつしの名探偵",
      copyright: "©TBS ©Phoenixx Developed by Happymeal",
    },
    {
      imageUrl1: "mebius.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/miasmabreaker/",
      text:
        "闇夜を撃ち祓え！！<br/>ミアズマブレイカーは全方位から襲い来る大量の悪霊（ミアズマ）を 祓っていくツインスティックアクションシューティングです。",
      gametitle: "宵祓い探偵 ミアズマブレイカー",
      copyright: "©mebius.",
    },
    {
      imageUrl1: "mebius2.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/steelempire/",
      text:
        "スチームパンクな世界観の昔ながらのシューティングゲームです。メガドライブ、ゲームボーイアドバンス、ニンテンドー3DSでリリースされ、コアなファンも多い『鋼鉄帝国』。<br/>避けて撃つ、シューティングゲームの原点を楽しんでください。",
      gametitle: "鋼鉄帝国-Steel Empire-クロニクル",
      copyright: "©STARFISH-SD INC. Development and management by mebius.",
    },

    {
      imageUrl1: "re_image.jpg",
      title: "ロケットエンジン",
      linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      linkUrl2: "http://studio-siesta.mails.ne.jp/twf/index.html",
      text:
        "１６年間にわたるシリーズのすべてが詰まった集大成的大ボリューム！　圧倒的ジャラジャラ感がクセになる唯一無二のプレイフィーリングは、初心者から上級者まですべてのユーザーが必ず楽しめます！<br/>今回のイベントでは、追加DLCキャラクター「レミエル」と「コットン」を先行プレイ可能です！　是非遊びに来てくださいね！",
      gametitle: "トラブル☆ウィッチーズ ふぁいなる！ ～アマルガムの娘たち～",
      copyright: "©Rocket-Engine Co., Ltd. StudioSiestA 2016 2023",
    },
    {
      imageUrl1: "petidepot.jpg",
      title: "プチデポット",
      //linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      linkUrl2: "https://globule.info/gnosia/",
      text:
        "『グノーシア』はＳＦ世界を舞台にしたいわゆる人狼系ゲームを一人でも遊べるようにしたものです。１プレイは１５分程度で、周回するたびに、主人公及び各キャラクターの配役や展開が変化します。",
      gametitle: "グノーシア",
      copyright: "©2019-2024 Petit Depotto",
    },
    {
      imageUrl1: "kemco.jpg",
      title: "ケムコ",
      linkUrl1: "https://www.kemco.jp",
      linkUrl2: "https://www.kemco.jp/game/alphadia1-2/ja/",
      text:
        "シリーズ累計50万本突破のファンタジーRPG『アルファディア』シリーズ、始まりの二作を一本のゲームにしたリメイク版です。Ⅰ、Ⅱそれぞれご試遊いただけます。<br/>ドット絵コマンドバトルがお好きな方は是非遊びに来てくださいね！",
      gametitle: "アルファディアⅠ＆Ⅱ",
      copyright: "© 2004-2024 KEMCO",
    },

    {
      imageUrl1: "busirodo.jpg",
      title: "ブシロードゲームズ",
      linkUrl1: "https://bushiroadgames.com/",
      linkUrl2: "https://macross-si.bushiroadgames.com/",
      text:
        "40年の歴史を誇るSFアニメの金字塔「マクロス」シリーズの完全新作スクロールシューティングゲームが2024年3月14日(木)発売！",
      gametitle: "マクロス -Shooting Insight-",
      copyright:
        "©'84,'92,'94,'95,'97,'02,'15 BIGWEST ©'07 BIGWEST/MFP・M ©bushiroad All Rights Reserved.",
    },
    {
      imageUrl1: "busirodo_2.jpg",
      title: "ブシロードゲームズ",
      linkUrl1: "https://bushiroadgames.com/",
      linkUrl2: "https://goblinslayer.bushiroadgames.com",
      text:
        "「ゴブリンスレイヤー」初のコンソールゲームがタクティクスRPGとして登場！<br/>オリジナルキャラクターを中心に原作キャラクターも登場するオリジナルストーリーと、あなたの一手が戦局を左右する戦略的なバトルを楽しもう！",
      gametitle: "ゴブリンスレイヤー -ANOTHER ADVENTURER- NIGHTMARE FEAST",
      copyright:
        "©蝸牛くも・SBクリエイティブ/ゴブリンスレイヤー2製作委員会　©bushiroad All Rights Reserved.",
    },
    {
      imageUrl1: "RS34_IllveloSwamp.jpg",
      title: "RS34",
      linkUrl1: "https://rs34.co.jp/index.html",
      linkUrl2: "https://rs34.co.jp/game/illveloswamp/illveloswamp_index.html",
      text:
        "─沼。<br/>「100」のステージ、「1000を超えるオーダー（ミッション）」 2019年に発売した『イルベロスウォンプ』<br/>まだ出典するのか？！<br/>プレイアブル出典だけではなく、 　RS34によるラジルギ２＆発表トークイベント＆サイン会開催予定。<br/>またRS34のアウトレット品もファミコンショップマリオ新橋店さんで委託販売します！是非お立寄りください！",
      gametitle: "イルベロスウォンプ",
      copyright: "©RS34.Published by mebius.",
    },

    // {
    //   imageUrl1: "OperaHouse2.jpg",
    //   title: "オペラハウス",
    //   linkUrl1: "https://www.opera-house.jp/",
    //   // linkUrl2: "http://d-mebius.com/toho_w_p/",
    //   text: "ゲーム展示＆対戦会<br/>対戦ゲームで勝った方に粗品をプレゼント",
    //   gametitle: "マッドストーカー X68000 Z",
    // },
    {
      imageUrl1: "OperaHouse.jpg",
      title: "オペラハウス",
      linkUrl1: "https://www.opera-house.jp/",
      // linkUrl2: "http://d-mebius.com/toho_w_p/",
      text:
        "デモ展示「ラスグレイブ探偵譚」（MSXturboR、MSX2+、MSX0）「MECHANICAL BRAIN ReHash」（MSXturboR）「あすか120％ for X68000 Z」（X68000 Z）「MSX0 Stack」「MSX0 CARD」「MSXPLAYer」「MSXturboR」「X68000 Z」にてゲームのデモ展示を行います。<br/>あすか120％は対戦プレイ、MECHANICAL BRAINはα版をプレイして頂けます。その他、X68000 Z用に準備中のゲーム2～3タイトルをデモ展示します。",
      gametitle: "ラスグレイブ探偵譚 MSX",
    },
    {
      imageUrl1: "ThousandGames.jpg",
      title: "サウザンドゲームズ",
      linkUrl1: "https://www.thousandgames.net/",
      linkUrl2: "https://store.steampowered.com/app/1754460/QUESTER/",
      text:
        "『QUESTER』はハックアンドスラッシュに特化したダンジョン探索RPGです。漫画家・萩原一至が構築した退廃未来の世界観を元に、加藤ヒロノリがゲームデザインを行いました。",
      gametitle: "QUESTER",
      copyright: "©萩原一至・加藤ヒロノリ・Thousand Games ©Thousand Games",
    },
    {
      imageUrl1: "daisyworld.jpg",
      title: "デイジーワールド",
      linkUrl1: "https://www.daisyw0rld.com/",
      linkUrl2: "https://daisyw0rld.booth.pm/",
      text:
        "各社様ゲーム作品Tシャツ、トートバッグ、サコッシュの販売を行います<br/>会場特別価格品もございますので、是非ご覧になってくださいませ",
      gametitle: "物販",
      copyright: "",
    },
    {
      imageUrl1: "shanon.jpg",
      title: "シャノン",
      linkUrl1: "https://takiya.info/shannon/",
      //linkUrl2: "https://daisyw0rld.booth.pm/",
      text:
        "学園に潜む快楽殺人鬼集団の日常を描いた新作「アパシー殺人クラブ」の試遊ができます。恐ろしいサイコパスなのにどこか憎めない彼らの失敗続きのコミカルな作品となっています。また試遊していただいた方にポストカードを差し上げます。",
      gametitle: "アパシー殺人クラブ",
      copyright: "©飯島多紀哉",
    },
  ],
};
export default CompanyData;
